<template>
  <div class="clearfix py--20px">
    <div class="col-m-2 p--0px">
      <p class="font--14px text--gray mt--8px">{{label}}</p>
    </div>
    <div class="col-m-10">
      <form-input
        v-bind="$attrs"
        :value="value"
        :error="error"
        :readonly="readonly"
        :helpText="helpText"
        @input="input"
        class="form-input--md"
      ></form-input>
      <!-- <form-error v-bind="$attrs" /> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String },
    error: { type: Object, required: true },
    label: { type: String, default: '' },
    readonly: { type: Boolean, default: false },
    helpText: { type: String, default: '' }
  },
  methods: {
    input (value) {
      this.$emit('input', value)
    }
  },
  // computed: {
  //   listeners () {
  //     return {
  //       ...this.$listeners,
  //       input: event => {
  //         console.log('---------------')
  //         this.$emit('input', event.target.value)
  //       }
  //     }
  //   }
  // },
  components: {
    FormInput: () => import('@/component/ui2/form/FormInput')
    // FormError: () => import('@/component/ui/FormError')
  }
}
</script>
